<template>
  <div class="mb-10">
    <p class="font-weight-bold body-1">{{ title }}</p>
    <v-card outlined>
      <v-data-table
        :headers="paymentFortnightHeaders"
        :items="payments"
        item-key="host_total"
        hide-default-footer
        single-expand
        disable-sort
        show-expand
      >
        <template v-slot:item.host="{ item }">
          {{ hostName(item) }}
          <span class="d-block caption grey--text">
            {{ hostUsername(item) }}
          </span>
        </template>
        <template v-slot:item.host_total="{ item }">
          {{ formatMoney(item.host_total) }}
        </template>
        <template v-slot:[`expanded-item`]="{ headers, item: parentItem }">
          <CustomerListPending :headers="headers" :customers="parentItem.host_pending_customer_invoice_payment_responses" />
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { paymentFortnightHeaders } from '../../adminInvoiceHeaders'
import { catalogMonetary } from '@/util/catalog'
import { mapActions } from 'vuex'

import CustomerListPending from './CustomerListPending'

export default {
  name: 'AdminInvoicesFortnight',

  components: {
    CustomerListPending,
  },

  props: {
    payments: {
      type: Array,
      required: false,
    },

    title: {
      type: String,
      required: true,
    },
  },

  methods: {
    ...mapActions(['openModal', 'showErrorMessage']),

    hostName(item) {
      return item.host.name ?? '---'
    },

    hostUsername(item) {
      return item.host.username ?? '---'
    },

    formatMoney(value) {
      return catalogMonetary(value)
    },
  },

  data() {
    return {
      paymentFortnightHeaders,
    }
  }
}
</script>
